import React, { useEffect } from "react";
import styles from "./styles.module.scss";
import theme from "../../Styles/theme.scss";
// Icons
import { CloseIcon, SuccessTickIcon } from "../../Styles/Icons/DesignSystem";
// Components
import CTAButton from "../CTAButton";
import SecondaryButton from "Components/SecondaryButton";
// Types
import { ServiceUser } from "../../Services/Hooks/useAddNewStaff";

type CreateFriendOrFamilySplashType = {
  onCloseForm?: () => void;
  friendOrFamily:
    | undefined
    | {
        name: string;
        id: string;
        email: string;
      };
  serviceUsersAssigned: undefined | ServiceUser[];
  isSuccess: boolean;
  createStaffEmailError: string | null;
  emailOfFriendOrFamily: string | null;
  resetForm: () => void;
  onTrack: (data?: any) => void;
};

const CreateFriendOrFamilySplash = ({
  onCloseForm,
  friendOrFamily,
  serviceUsersAssigned,
  createStaffEmailError,
  isSuccess,
  resetForm,
  onTrack,
}: CreateFriendOrFamilySplashType) => {
  const isEmailUnavailable =
    createStaffEmailError && createStaffEmailError === "email unavailable";
  const emailIsUnavailable = `An account already exists with this email. Please contact support to connect their account.`;

  const genericError =
    "We could not create this friend or family. Please contact support for assistance.";
  const errorReason = `${createStaffEmailError && isEmailUnavailable ? emailIsUnavailable : ""}`;
  const friendOrFamilyEmail = friendOrFamily?.email ? friendOrFamily.email : "";

  useEffect(() => {
    onTrack({
      event: "invite_family_result",
      result: isSuccess
        ? "success"
        : emailIsUnavailable
          ? "error_user_already_exists"
          : "generic_error",
    });
  }, [emailIsUnavailable, isSuccess, onTrack]);

  return (
    <div className={styles.splash_container}>
      {isSuccess ? (
        <SuccessTickIcon colour={theme.expected2} width={60} />
      ) : (
        <CloseIcon color={theme.risk4} width={60} />
      )}

      <div className={styles.staff_splash_title}>
        {isSuccess ? "Invite sent!" : "Sorry, there's been a problem."}
      </div>

      {!isSuccess ? (
        <div className={styles.error_message}>
          {errorReason ? errorReason : genericError} <br />
          <br />
          +44 (0)758 800 8527 or support@intelligentlilli.com
        </div>
      ) : serviceUsersAssigned ? (
        <div className={styles.staff_splash_message}>
          <strong>{friendOrFamilyEmail}</strong> is now connected to{" "}
          {serviceUsersAssigned.map((su, index) => {
            // do not put a comma after their name when there is only 1 resident assigned to them
            // or when the resident is the last one in the list
            if (index === serviceUsersAssigned.length - 1) {
              return <span key={index}>{su?.label}</span>;
            } // for all other residents, put a comma after their name
            else {
              return <span key={index}>{su?.label}, </span>;
            }
          })}{" "}
          and has been emailed instructions on how to download and log in to the
          Lilli app.
        </div>
      ) : (
        <div className={styles.staff_splash_message}>
          <strong>{friendOrFamilyEmail}</strong> has been emailed instructions
          on how to download the Lilli app. However, could not connect them to
          this person. Please contact +44 (0)758 800 8527 or
          support@intelligentlilli.com to connect the accounts.
        </div>
      )}

      <SecondaryButton className={styles.add_another} onClick={resetForm}>
        Add another friend or family
      </SecondaryButton>
      <CTAButton type="submit" onClick={onCloseForm}>
        Done
      </CTAButton>
    </div>
  );
};

export default CreateFriendOrFamilySplash;
